import styled from 'vue-styled-components';

export const Container = styled.main`
display: flex;
flex-direction: column;
gap: 62px;
padding-top: 140px;
`;
